const formatShortValue = (value) => {
  if (Number.isInteger(value)) {
    return String(value);
  }
  return value.toFixed(1).replace(/\.0$/, '');
};

const formatSmallValue = (value) => {
  if (Number.isInteger(value)) {
    return String(value);
  }
  return value.toFixed(2).replace(/\.0+$/, '');
};

export const abbreviateNumber = (rawValue) => {
  const value = Number(rawValue);
  if (!Number.isFinite(value)) {
    return '0';
  }

  const sign = value < 0 ? '-' : '';
  const absValue = Math.abs(value);

  if (absValue >= 1_000_000_000) {
    return `${sign}${formatShortValue(absValue / 1_000_000_000)}b`;
  }
  if (absValue >= 1_000_000) {
    return `${sign}${formatShortValue(absValue / 1_000_000)}m`;
  }
  if (absValue >= 1_000) {
    return `${sign}${formatShortValue(absValue / 1_000)}k`;
  }

  return `${sign}${formatSmallValue(absValue)}`;
};

export const formatCurrencyShort = (rawValue, currency = 'PKR') => {
  const value = Number(rawValue);
  if (!Number.isFinite(value)) {
    return `${currency} 0`;
  }

  const absValue = Math.abs(value);
  if (absValue < 1_000) {
    return new Intl.NumberFormat('en-PK', {
      style: 'currency',
      currency
    }).format(value);
  }

  return `${currency} ${abbreviateNumber(value)}`;
};
